import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { to: '/', label: 'About' },
    { to: '/projects', label: 'Projects' },
    { to: '/blog', label: 'Blog' },
    { to: '/contact', label: 'Contact' },
  ];

  return (
    <header
      className={`sticky top-[2px] z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-slate-900/90 backdrop-blur-md shadow-lg shadow-slate-900/50 border-b border-slate-800'
          : 'bg-slate-900/30 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        <a
          href="https://www.jedrychk.com/"
          className="text-xl font-bold tracking-tight group"
        >
          <span className="text-violet-400 group-hover:text-violet-300 transition-colors duration-200">
            Kajetan{' '}
          </span>
          <span className="text-slate-100">Jedrych</span>
        </a>

        <nav>
          <ul className="flex items-center gap-8">
            {navLinks.map(({ to, label }) => {
              const isActive = location.pathname === to;
              return (
                <li key={to}>
                  <Link
                    to={to}
                    className={`relative text-sm font-medium transition-colors duration-200 group ${
                      isActive ? 'text-violet-400' : 'text-slate-400 hover:text-slate-100'
                    }`}
                  >
                    {label}
                    <span
                      className={`absolute -bottom-1 left-0 h-px bg-gradient-to-r from-violet-500 to-cyan-400 transition-all duration-300 ${
                        isActive ? 'w-full' : 'w-0 group-hover:w-full'
                      }`}
                    />
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
